export default __webpack_public_path__ + "static/media/img-industry-retail.80465e94.svg";